import { Box, createStyles } from '@mantine/core';

import dt from '~/testing';

import { Avatar } from '../Avatar/Avatar';

type PageHeaderAvatarProps = {
  src: string;
  isSidePanel?: boolean;
};

const useStyles = createStyles(
  (theme, { isSidePanel }: Pick<PageHeaderAvatarProps, 'isSidePanel'>) => ({
    wrapper: {
      width: theme.other.screenWidth.lg,
      marginBottom: theme.spacing.sm,
      position: 'absolute',
      top: 20,

      ...(isSidePanel
        ? {
            width: '100%',
            opacity: 1,
          }
        : {
            [theme.fn.smallerThan('lg')]: {
              width: '100%',
            },
            [theme.fn.smallerThan('xs')]: {
              display: 'block',
            },
          }),
    },
    icon: {
      borderRadius: '50%',
      position: 'absolute',
      width: 85,
      height: 85,
      transform: 'translateY(-78px)',
      border: '1px solid white',
      overflow: 'hidden',
      transitionDuration: '0.35s',
      transitionTimingFunction: 'linear',
      transitionProperty: 'transform, width, height',
      ...(isSidePanel
        ? {
            width: 72,
            height: 72,
            marginTop: theme.spacing.sm,
          }
        : {
            [theme.fn.smallerThan('lg')]: {
              transform: 'translateY(-70px)',
            },
            [theme.fn.smallerThan('xs')]: {
              transform: 'translateY(-78px)',
            },
            [theme.fn.smallerThan('md')]: {
              width: 72,
              height: 72,
              marginTop: theme.spacing.sm,
            },
          }),
    },
  })
);

export function PageHeaderAvatar({ src, isSidePanel }: PageHeaderAvatarProps) {
  const { classes } = useStyles({ isSidePanel });

  return (
    <Box className={classes.wrapper}>
      <Avatar
        className={classes.icon}
        data-test-id={dt.contestDetail.page.header.thumbnail}
        radius="xl"
        src={src}
        skipNextImageCache
      />
    </Box>
  );
}
